module.exports = __webpack_public_path__ + "static/media/python.37853310.png";